import { Checkbox, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setModalConsent } from "../../../../../store/signature/signatureSlice";

const { Paragraph, Text } = Typography;

export default function ConsentModal() {
  const dispatch = useDispatch();
  const { modalConsent } = useSelector((s) => s.signature);

  return (
    <div>
      <Paragraph className="consent-text">
        By checking the box below and clicking <Text strong>Accept</Text>, you
        agree to:
      </Paragraph>

      <ol style={{ paddingLeft: 20, marginTop: 0, marginBottom: 16 }}>
        <li>
          <Paragraph style={{ marginBottom: 4 }}>
            Receive all documents for this application in electronic form; and
          </Paragraph>
        </li>
        <li>
          <Paragraph style={{ marginBottom: 0 }}>
            Sign these documents electronically. Your electronic signature will
            have the same legal effect as a handwritten signature under&nbsp;
            <a
              href="https://laws-lois.justice.gc.ca/eng/acts/P-8.6/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Canada’s&nbsp;PIPEDA
            </a>
            .
          </Paragraph>
        </li>
      </ol>

      <Paragraph style={{ marginBottom: 16 }}>
        You can withdraw this consent or request paper copies at any time by
        contacting us.
      </Paragraph>

      <Checkbox
        checked={modalConsent}
        onChange={(e) => dispatch(setModalConsent(e.target.checked))}
      >
        I have read and agree.
      </Checkbox>
    </div>
  );
}
